import React, { useEffect, useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
  CircularProgress,
  Alert,
  Link,
} from '@mui/material';
import Layout from '../../components/Layout';
import api from '../../services/api';

const googleMapsQueryUrl = (address) =>
  `https://maps.google.com/?q=${encodeURIComponent(address || '')}`;

const DriverDepots = () => {
  const [depots, setDepots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadDepots();
  }, []);

  const loadDepots = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await api.get('/depots/');
      const data = Array.isArray(res.data) ? res.data : res.data?.results || [];
      setDepots(data);
    } catch (e) {
      console.error('Failed to load depots:', e);
      setError('Failed to load fuel depots.');
      setDepots([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Layout>
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="50vh">
          <CircularProgress />
        </Box>
      </Layout>
    );
  }

  return (
    <Layout>
      <Container>
        <Typography variant="h4" sx={{ mb: 1 }}>
          Fuel depots
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Available refuel locations for your assigned routes.
        </Typography>

        {error && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
            {error}
          </Alert>
        )}

        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Operator</TableCell>
                <TableCell>Address</TableCell>
                <TableCell>Fuels</TableCell>
                <TableCell>Contact</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {depots.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5}>
                    <Typography variant="body2" color="text.secondary">
                      No fuel depots available.
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : (
                depots.map((d) => (
                  <TableRow key={d.id}>
                    <TableCell>{d.name}</TableCell>
                    <TableCell>{d.parent_company}</TableCell>
                    <TableCell>
                      <Link href={googleMapsQueryUrl(d.full_address)} target="_blank" rel="noopener noreferrer">
                        {d.full_address}
                      </Link>
                    </TableCell>
                    <TableCell>
                      {d.has_diesel && <Chip size="small" label="Diesel" sx={{ mr: 0.5 }} />}
                      {d.has_def && <Chip size="small" label="DEF" />}
                    </TableCell>
                    <TableCell>
                      {[d.contact_name, d.contact_phone, d.contact_email].filter(Boolean).join(' · ') || '—'}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Container>
    </Layout>
  );
};

export default DriverDepots;

